module.exports = __webpack_public_path__ + "static/img/tit2.3ca34326.png";